import { defineStore } from 'pinia'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'

import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import { uuid } from 'vue3-uuid'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import { CONTRACT_API } from '@/modules/contract/constants/contract.api.uri.const.ts'
import { parseFilter } from '@/utils/filterHelper.ts'
import { parseDataTable } from '@/modules/contract/helper/listing.ts'
import ContractSubjectCell from '@/modules/contract/components/Table/ContractSubjectCell.vue'
import CodeCell from '@/onenetwork/components/datatable/CodeCell.vue'
import ActorCell from '@/modules/contract/components/Table/ActorCell.vue'
import ContractStepCell from '@/modules/contract/components/Table/ContractStepCell.vue'
import ContractCommissionCell from '@/modules/contract/components/Table/ContractCommissionCell.vue'
import ContractAssetCell from '@/modules/contract/components/Table/ContractAssetCell.vue'
import {markRaw} from 'vue'

export interface tabItem {
  id: string,
  label: string,
  active: boolean,
}

export enum ContractListActionTypes {
  FILTERING = 'FILTERING',
  PENDING= "PENDING",
  FETCHING= "FETCHING",
  FETCH_SUCCESS = "FETCH_SUCCESS",
  FETCH_FAILURE = "FETCH_FAILURE",
}

interface ContractListStore {
  action_type: ContractListActionTypes,
  action_mess: string,
  uuid: string,
  data: Object,
  filter: Array<{
    key: string,
    type: string,
    label: string,
    placeholder: string,
    value: any,
    options?: Array<{label: string, value: string}>
  }>,
  pageSize: number,
  page: number,
  tabs: Array<any>,
  tableConfig: any,
  selectedIds: Array<string|number>,
}

export const useContractListStore = defineStore('contract.list', {
  state: (): ContractListStore => ({
    action_type: ContractListActionTypes.PENDING,
    action_mess: "",
    uuid: '',
    data: {
      list: [],
      totalRecords: 0,
      totalPage: 0,
    },
    filter: [
      {
        key: 'sign_date',
        type: 'date-range',
        label: 'Lọc theo ngày ký',
        placeholder: 'Chọn ngày',
        value: '',
      },
      {
        key: 'keyword',
        type: 'taginput',
        label: 'Lọc theo tiêu đề',
        placeholder: 'Nhập tiêu đề',
        value: '',
      },
      {
        key: 'code',
        type: 'taginput',
        label: 'Lọc theo mã HĐ',
        placeholder: 'Nhập mã HĐ',
        value: '',
      },
      {
        key: 'type',
        type: 'select-multiple',
        label: 'Lọc theo loại hợp đồng',
        placeholder: 'Chọn phân loại',
        value: '',
        options: [
          { label: 'HĐKG Độc quyền', value: "HDKGDQ"},
          { label: 'HĐKG Chính chủ', value: "HDKGCC"},
        ],
      },
      {
        key: 'progress',
        type: 'select-multiple',
        label: 'Lọc theo tình trạng',
        placeholder: 'Chọn tiến độ',
        value: '',
        options: [
          { label: 'Khởi tạo', value: "KHOI_TAO"},
          { label: 'Đã ký', value: "DA_KY"},
          { label: 'Đang tiến hành', value: "THUC_HIEN"},
          { label: 'Đã chốt deal', value: "CHOT_DEAL"},
          { label: 'Đã quyết toán', value: "QUYET_TOAN"},
          { label: 'Đã hoàn tất', value: "HOAN_TAT"},
        ],
      },
      {
        key: 'sellers',
        type: 'account-selector',
        label: 'Lọc theo khách bán/cho thuê',
        placeholder: '',
        value: '',
      },
      {
        key: 'seller_brokers',
        type: 'account-selector',
        label: 'Lọc theo MG bán/cho thuê',
        placeholder: '',
        value: '',
      },
      {
        key: 'buyers',
        type: 'account-selector',
        label: 'Lọc theo người mua/thuê',
        placeholder: '',
        value: '',
      },
      {
        key: 'buyers_brokers',
        type: 'account-selector',
        label: 'Lọc theo MG mua/thuê',
        placeholder: '',
        value: '',
      },
    ],
    pageSize: 10,
    page: 1,
    tabs: [
      {
        id: 'list',
        label: 'Danh sách hợp đồng',
        active: true,
      }
    ],
    tableConfig: {
      canShowHide: true,
      columns: {
        code: { label: 'Mã HĐ', component: markRaw(CodeCell), class: '', visible: true, sort: false, config: {} },
        type: { label: 'Loại HĐ', component: markRaw(TagCell), class: '', visible: true, sort: false, config: {} },
        subject: { label: 'Tiêu đề HĐ', component: markRaw(ContractSubjectCell), class: '', visible: true, sort: false, config: {} },
        asset: { label: 'Tài sản', component: markRaw(ContractAssetCell), class: '', visible: true, sort: false, config: {} },
        seller: { label: 'Khách bán/cho thuê', component: markRaw(ActorCell), class: '', visible: true, sort: false, config: {} },
        buyer: { label: 'Khách mua/thuê', component: markRaw(ActorCell), class: '', visible: true, sort: false, config: {} },
        commission: { label: 'Tỉ lệ hoa hồng', component: markRaw(ContractCommissionCell), class: '', visible: true, sort: false, config: {} },
        status: { label: 'Trạng thái', component: markRaw(ContractStepCell), class: '', visible: true, sort: false, config: {} },
        signed_at: { label: 'Ngày ký', component: markRaw(DateTimeCell), class: '', visible: true, sort: '', config: {} },
        created_at: { label: 'Ngày cập nhật', component: markRaw(DateTimeCell), class: '', visible: true, sort: '', config: {} },
        action_by: { label: 'Người cập nhật', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
      }
    },
    selectedIds: []
  }),
  getters: {
    sortFilter: state => {
      const sort: any = []
      if(Object.keys(state.tableConfig?.columns).length>0){
        Object.keys(state.tableConfig?.columns).forEach(col => {
          if(state.tableConfig.columns[col].sort) {
            sort.push([col, state.tableConfig.columns[col].sort])
          }
        })
      }
      return sort
    },
  },
  actions: {
    //TAB ACTION
    changeTab (targetId: string) {

      for (const tab of this.tabs) {
        tab.active = (tab.id === targetId)
      }
    },
    closeTab (targetId: string) {
      const index = this.tabs.findIndex(tab => tab.id === targetId)
      if (index !== -1) {
        this.tabs.splice(index, 1)
      }
    },
    closeAllTab () {
      this.tabs = [{
        id: 'list',
        label: 'Danh sách hợp đồng',
        active: true,
      }]
    },
    newTab (item: tabItem) {
      const exists = this.tabs.some(tab => tab.id === item.id)
      if (!exists) {
        this.tabs.push(item)
      }
      this.changeTab(item.id)
    },

    //FILTER ACTION
    setFilter (filter: any) {
      this.filter = filter
      this.action_type = ContractListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changeFilter (key: string, value: any) {
      const filterItem = this.filter.find((item: {key: string}) => item.key === key)
      if (filterItem) {
        filterItem.value = value
        this.action_type = ContractListActionTypes.FILTERING
        this.uuid = uuid.v4()
      }
    },
    putFilter(key: string, value: any) {
      this.filter = this.filter.map((field) => {
        if (field.key === key) {
          return { ...field, value: value }
        }
        return field
      })
    },

    //PAGE ACTION
    changePage (page: number) {
      this.page = page
      this.action_type = ContractListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changePageSize (size: number) {
      this.pageSize = size
      this.page = 1
      this.action_type = ContractListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //TABLE CONFIG ACTION
    toggleColumnVisibility(columnCode: string, visible: boolean) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].visible = visible
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    toggleSort(columnCode: string, sort: string) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].sort = sort
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },

    //DATA ACTION
    async fetchList(){
      return new Promise(async (resolve, reject) => {
        try{
          this.action_type = ContractListActionTypes.FETCHING
          const _filter = {
            page: this.page,
            page_size: this.pageSize,
            sort: this.sortFilter,
            ...parseFilter(this.filter),
            relations: [
              'seller', 'sellerBroker', 'buyer', 'buyerBroker', 'listing.realEstate',
            ]
          }

          const res = await APIClient.get(CONTRACT_API, {
            params: _filter
          })
          const { data } = res.data
          this.data = {
            list: parseDataTable(data.data),
            totalRecords: data.total,
            totalPage: data.to,
          }
          this.action_type = ContractListActionTypes.FETCH_SUCCESS
          resolve(res)
        } catch (e) {
          this.action_type = ContractListActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    }
  }
})
